import React, { useState, useEffect } from "react";
import { moodValues } from "../../redux/constants";
import { Link } from "react-router-dom";
import { ExclamationIcon } from "@heroicons/react/solid";

export default function TableBody({ rows }) {
  const [matches, setMatches] = useState(
    window.matchMedia("(min-width: 1024px)").matches
  );

  useEffect(() => {
    window
      .matchMedia("(min-width: 1024px)")
      .addEventListener("change", (e) => setMatches(e.matches));
  }, []);

  return (
    <div className="w-full flex flex-col divide-y divide-gray-200 pb-8 max-h-full overflow-y-auto">
      {rows.map((mood) => (
        <div className="grid grid-cols-1 lg:grid-cols-8 w-full items-center">
          <div className="px-6 py-4 whitespace-nowrap">
            <div className="flex items-left">
              <div className="ml-4">
                <Link
                  to={"/users/" + String(mood?.user?._id?.$oid)}
                  className="text-sm text-left font-medium text-gray-900"
                >
                  {mood?.user?.firstName + " " + mood?.user?.lastName}
                </Link>
              </div>
            </div>
          </div>
          <span className="px-6 py-4 flex flex-row gap-x-2 whitespace-nowrap text-left text-sm text-gray-500">
            <span
              className={
                "flex w-4  h-4 rounded-xl opacity-70 " +
                "bg-" +
                moodValues[mood?.mood]
              }
            />
            {moodValues[mood?.mood]}
          </span>
          <span className="px-6 py-4 whitespace-nowrap text-left text-sm text-gray-500">
            {mood?.priorities.length > 0 ? (
              <ExclamationIcon
                className="h-6 w-6 text-red-600 cursor-pointer"
                onClick={() => (window.location = "priorities")}
              />
            ) : null}
          </span>
          <span className="px-6 py-4 whitespace-nowrap text-left text-sm text-gray-500">
            {mood?.categories.join(", ")}
          </span>
          <span className="px-6 py-4 whitespace-nowrap text-left text-sm text-gray-500">
            {mood?.user?.department}
          </span>
          <span className="px-6 py-4 break-all text-left text-sm text-gray-500">
            {mood?.note}
          </span>
          <span className="px-6 py-4 whitespace-nowrap text-left text-sm text-gray-500">
            {new Date(mood?.time?.$date).toLocaleString("en-GB", {
              timeZone: "UTC",
            })}
          </span>
          <span className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
            {!mood?.answered && (
              <Link
                className="my-2 py-2 px-6 text-white rounded bg-Sad"
                to={"/conversations/" + String(mood?.user?._id?.$oid)}
              >
                Contact
              </Link>
            )}
            {mood?.answered && (
              <label className="my-2 mr-auto py-2 px-4 text-white rounded bg-green-600">
                Contacted
              </label>
            )}
          </span>
        </div>
      ))}
    </div>
  );
}
